import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = value =>
  isValidGlobalBehaviour(value, 'alphaTwoSpaces') ? undefined : 'Required';

const FirstName = () => (
  <Content>
    {({ personDetailsFirstName = '', firstLastNameError = '' }) => (
      <Field name="firstName" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="firstName"
              hasError={touched && !!error}
              title={personDetailsFirstName}
              validationMessage={firstLastNameError}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="firstName" component="input" validate={required}>
                {({ input }) => (
                  <BlockFieldColumn column={6}>
                    <Input name="firstName" type="text" {...input} maxLength={35} />
                  </BlockFieldColumn>
                )}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

export default FirstName;
